import {
	useEventListener,
	useIntersectionObserver,
	useIntervalFn,
	useMutationObserver,
	useResizeObserver,
} from "@vueuse/core"
import { onMounted, shallowRef, toValue, type MaybeRef } from "vue"

export function useElementClientPosition(
	element: MaybeRef<HTMLElement | SVGElement | undefined>,
	refreshIntervalMs = 2_500
) {
	const bounds = shallowRef(toValue(element)?.getBoundingClientRect() ?? new DOMRect())

	function refresh() {
		const el = toValue(element)
		if (el) {
			const existingBounds = bounds.value
			const newBounds = el.getBoundingClientRect()
			if (
				existingBounds.x !== newBounds.x ||
				existingBounds.y !== newBounds.y ||
				existingBounds.width !== newBounds.width ||
				existingBounds.height !== newBounds.height
			) {
				bounds.value = newBounds
			}
		}
	}

	onMounted(refresh)

	useIntervalFn(refresh, refreshIntervalMs)

	useMutationObserver(element, refresh, {
		attributeFilter: ["style", "class"],
	})

	useIntersectionObserver(element, refresh)
	useResizeObserver(element, refresh)

	useEventListener("resize", refresh, { passive: true })
	useEventListener("scroll", refresh, { capture: true, passive: true })

	return {
		bounds,
		refresh,
	}
}
